import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useMemo } from 'react';
import { useAddFavorite } from '~/hooks/common/favorites';
import { ListenerEvent, type ListenerEventType } from './constants';

type AddFavoriteMessage = IncomingMessage<
  ListenerEventType,
  {
    stockNumber: number;
    vehicleId: number;
  }
>;

function isAddFavoriteMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is AddFavoriteMessage {
  return (
    message.event === ListenerEvent.AddFavorite &&
    message.payload.vehicleId != null
  );
}

export default function useAddFavoriteHandler(): MessageHandler<ListenerEventType> {
  const addFavorite = useAddFavorite({});

  return useMemo(
    () =>
      new MessageHandler(
        isAddFavoriteMessage,
        (message: AddFavoriteMessage) => {
          void addFavorite(message.payload);
        }
      ),
    [addFavorite]
  );
}
